import React from "react";
import { bool, string } from "prop-types";
import cx from "classnames";

const propTypes = {
  /** Id of the tabpanel this tab controls. */
  controls: string.isRequired,
  isActive: bool,
  /** Disabled state. */
  isDisabled: bool,
};

const CLASS_TABLIST_ITEM = "tabnav__item";
const CLASS_TABLIST_TAB = "tabnav__tab";

const Tab = ({
  children,
  className,
  controls,
  isDisabled,
  isActive,
  ...other
}) => {
  const tabClasses = cx(
    CLASS_TABLIST_TAB,
    {
      "is-disabled": isDisabled,
      "is-active": isActive,
    },
    className
  );

  const tabindex = isActive ? 0 : -1;

  return (
    <li className={CLASS_TABLIST_ITEM} role="presentation">
      <button
        type="button"
        role="tab"
        className={tabClasses}
        aria-selected={isActive}
        aria-controls={controls}
        tabIndex={tabindex}
        aria-disabled={isDisabled}
        {...other}
      >
        {children}
      </button>
    </li>
  );
};

Tab.displayName = "Tab";
Tab.propTypes = propTypes;

export default Tab;
